import vacanciesFilter from '../modules/vacanciesFilter';
import filterGroup from '../modules/filterGroup';

const vacancies = () => {
  vacanciesFilter.initialize();
  filterGroup.initialize();
};

export default vacancies;
